import apiRequestService from '@/commonProject/service/apiRequestService';

export default class fileDownloadRepository {
    /**
     * ダウンロード履歴取得APIをコールする。
     * @param {Object} queryParam
     * @returns result
     */
    async fileDownloadRepository(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/dldhst', queryParam, idToken);
        return result;
    }

    /**
     * ダウンロード履歴更新APIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async putDownloadHistroyActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/dldhst', requestBody, idToken);
        return result;
    }
}
